import { Button, InputNumber, Slider } from 'antd';
import React, { useState } from 'react';

const AlignItemsContent = (props) => {
  const [lastValue, setLastValue] = useState(0.1);
  return (
    <>
      <p style={{ fontSize: "9pt" }}>Schrittgröße</p>
      <InputNumber
        style={{ maxWidth: 65 }}
        min={0}
        max={100}
        step={0.1}
        defaultValue={lastValue}
        onChange={(newValue) => {
          setLastValue(newValue);
        }}
      />
      <p style={{ fontSize: "9pt" }}>Skalierung X</p>
      <InputNumber
        min={1}
        max={100}
        step={lastValue}
        style={{ maxWidth: 65 }}
        value={props.gapX}
        onChange={(gap) => {
          props.setGapX(gap)
          props.scaleShapesInX(gap)
        }}
      />
      <p style={{ fontSize: "9pt" }}>Skalierung Y</p>
      <InputNumber
        min={1}
        max={100}
        step={lastValue}
        style={{ maxWidth: 65 }}
        value={props.gapY}
        onChange={(gap) => {
          props.setGapY(gap)
          props.scaleShapesInY(gap)
        }}
      />
    </>
  );
}

export default AlignItemsContent;
